import { DrAccount } from "@/services/model";

export interface BulkMoveFormValues {
  source: DrAccount;
  target: DrAccount | null;
  /** Checkbox values, hence strings. */
  simIds: string[];
}

export const BULK_MOVE_FORM_ID = "bulk-move-form";
